import Link from "react-scroll/modules/components/Link";
import React from "react";
import "./Navbar.css";
import pdf from "./Abhishek_Jha_Resume.pdf"
import { ResumeLink } from "../ResumeLink";


export default function Navbar() {
  
  return (

    <div className="navbar nav-link.home" id="nav-menu"  >
      <div className="logo">
        <h1 className="logo-h1">Abhishek Jha</h1>
      </div>
      
      <ul className="nav-ul">
        <Link to="home" smooth={true} duration={500} >
          <li class="nav-link home">Home</li>
        </Link>
        <Link to="about" smooth={true} duration={500}  >
          <li class="nav-link about">About</li>
        </Link>
        <Link to="skills" smooth={true} duration={500} >
          <li class="nav-link skills">Skills</li>
        </Link>
        <Link to="project" smooth={true} duration={500}  >
          <li class="nav-link projects">Projects</li>
        </Link>
        <Link to="Newcontact" smooth={true} duration={500}  >
          <li class="nav-link contact">Contact</li>
        </Link>
  
        <button id="resume-button-1" href={pdf} download onClick={ResumeLink} > <a href={pdf}  id="resume-link-1" download class="resumee" > Resume </a></button>


      </ul>

  
    </div>

 
  );
}